import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { ActiveSign, AgentName, Avatar, BadgeBlue, ContactNumber, Group, KeypadOption, ProfileBar, Sign, Time, Title, UserList } from '../styles/dialpadstyle';
import {
  FormWrapper,
  FormColumn,
  FormGroup,
  ControlLabel,
  FormControl,
  Button
} from 'modules/theme';

export class ChatListTheme extends Component {

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        {/* <ControlLabel required={props.required}>{label}</ControlLabel> */}
        <FormControl {...props} />
      </FormGroup>
    );
  }

  renderList(userImg, sign, name, text, time, badgeValue) {
    return (
      <ProfileBar style={{ padding: '0px', marginBottom: '10px' }}>
        <Avatar>
          <img src={userImg} />
          <ActiveSign><Sign className={sign} /></ActiveSign>
        </Avatar>
        <AgentName style={{ color: '#303030' }}>{name}<ContactNumber>{text}</ContactNumber></AgentName>
        <Time>
          {time}
          <BadgeBlue>{badgeValue}</BadgeBlue>
        </Time>
      </ProfileBar>
    )
  }

  render() {
    const { title, search, btnSearch } = this.props;
    return (
      <span style={{display: 'block', width: '100%'}}>
        <Title>
          {title}
        </Title>

        <Group>
          <form style={{ width: '88%' }}>
            <KeypadOption>
              <FormWrapper>
                {/* <FormColumn></FormColumn> */}
                <FormColumn>
                  {this.renderFormGroup('', {
                    defaultValue: '',
                    placeholder: 'Search...',
                    autoFocus: false,
                    required: true,
                    id: 'search',
                    value: '',
                    onChange: e => {
                      this.setState({ search: e.target.value });
                    }
                  })}
                </FormColumn>
              </FormWrapper>
            </KeypadOption>
            <Button
              btnStyle="link"
              type="simple"
              style={{ right: '-3px' }}
            >
              <img src={btnSearch} style={{ width: '38px' }} />
            </Button>
          </form>
        </Group>

        <UserList>
          {this.renderList(
            'images/Profile.png',
            'active',
            'Olivia Williams',
            `How are you?`,
            '01:18',
            '05'
          )}
          {this.renderList(
            'images/Profile.png',
            'offline',
            'Olivia Williams',
            `How are you?`,
            '01:18',
            '05'
          )}
          {this.renderList(
            'images/Profile.png',
            'busy',
            'Olivia Williams',
            `How are you?`,
            '01:18',
            '05'
          )}
          {this.renderList(
            'images/Profile.png',
            'active',
            'Olivia Williams',
            `How are you?`,
            '01:18',
            '05'
          )}
          {this.renderList(
            'images/Profile.png',
            'active',
            'Olivia Williams',
            `How are you?`,
            '01:18',
            '05'
          )}
          {this.renderList(
            'images/Profile.png',
            'active',
            'Olivia Williams',
            `How are you?`,
            '01:18',
            '05'
          )}
        </UserList>
      </span>
    )
  }
}

ChatListTheme.propTypes = {
};

ChatListTheme.contextTypes = {
  __: PropTypes.func
};

export default ChatListTheme


// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/ChatListTheme.js